module.exports = __webpack_public_path__ + "img/vehicle-photo-empty.2d5cc2d8.png";